import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    borderLeft: '4px solid #00E08E',
  },
  cardTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  cardContent: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  historico: {
    marginTop: theme.spacing(3),
  },
  historicoTitle: {
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    backgroundColor: '#00E08E',
    color: '#fff',
    paddingBottom: theme.spacing(2),
  },
  dialogContent: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
  },
  cancelButton: {
    borderRadius: 20,
    padding: '8px 22px',
    textTransform: 'none',
    fontWeight: 500,
  },
  confirmButton: {
    borderRadius: 20,
    padding: '8px 22px',
    textTransform: 'none',
    fontWeight: 500,
    backgroundColor: '#00E08E',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
  },
}));